// extracted by mini-css-extract-plugin
module.exports = {"header":"header__10U89","description":"description__11MFJ","innerContainer":"innerContainer__2mdQk","content":"content__3kwQn"};